import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

const JOB_TYPE_STATS_TABLE = "STATS_TABLE";
const PAGE_SIZE = 50;

export const useGetBackgroundJobs = (userId?: number, enabled = true) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`listBackgroundJobs`, JOB_TYPE_STATS_TABLE, userId],
    queryFn: ({ signal }) =>
      statsControllerApi.listBackgroundJobs(userId, JOB_TYPE_STATS_TABLE, 0, PAGE_SIZE, {
        signal,
      }),
    refetchInterval: 10000,
    // Вкладка stat diversity держится смонтированной (keepMounted) — без
    // enabled поллинг продолжался бы и на других вкладках.
    enabled,
  });
};
